var _style, _path, _g, _g2, _defs, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromonetwerk01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136.4 106.4",
    style: {
      enableBackground: "new 0 0 136.4 106.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A82880;}\r\n\t.st1{display:none;fill:#868686;}\r\n\t.st2{fill:#868686;}\r\n\t.st3{fill:#EDEDED;}\r\n\t.st4{fill:#A72880;}\r\n\t.st5{fill:#515254;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Marker_00000096778590506178575850000018254240258438271664_",
    className: "st0",
    d: "M68.2,21.5c-17.5,0-31.6,14.1-31.6,31.6 s14.1,31.6,31.6,31.6s31.6-14.1,31.6-31.6C99.9,35.6,85.7,21.5,68.2,21.5 M105,52.1c0,21.8-16.3,34-36.8,54.3 C47.3,86.3,31.5,74.3,31.5,52.1c0-20.3,16.5-36.8,36.8-36.8C88.5,15.3,105,31.8,105,52.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,26.3V80c2.4,1.3,4.9,2.3,7.6,2.8l0-59.3C61.5,24,59,25,56.6,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.2,81V25.3c-2.3-1-4.8-1.6-7.3-1.8v59.3C75.5,82.6,77.9,82,80.2,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,16.2c0,0,5.4-4.4,22.7-7.6s20.3-2.3,20.3-2.3s3.8,0.3,5.1,4.3c0.2,0.7,0.3,1.3,0.3,2l0.4,63.1 c0,0,0.1,4-4.7,5c-2.7,0-16,1.7-20,2.6c-4,0.8-13.7,3.1-16.2,4.3L81.4,95c0,0,2.1,1.1,7.3-1.1C94.3,91.6,111,88,111,88 s11.8-1.3,15.5-1.8c4-0.5,4.1-1,4.1-1s5-2.8,5.7-9.8c0.7-7-0.5-64.7-0.5-64.7s0-8-11-10.3c-12.3-2.5-36.2,5.7-40,7.3 s-7.7,3.5-9.6,5.3c-1.8,1.7-1.5,1.3-1.5,1.3S77,14.6,81.1,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.4,16.5c0,0-5.4-4.4-22.7-7.6S12.4,6.6,12.4,6.6S7.8,6.9,7.1,12L6.6,75.9c0,0-0.1,4,4.7,5 c2.7,0,16,1.7,20,2.6s13.7,3.1,16.2,4.3l7.5,7.5c0,0-2.1,1.1-7.3-1.1c-5.6-2.3-22.2-5.9-22.2-5.9S13.7,87,10,86.5 c-4-0.5-4.1-1-4.1-1s-5-2.8-5.7-9.8C-0.5,68.7,0.7,11,0.7,11s0-8,11-10.3c12.3-2.5,36.2,5.7,40,7.3s7.7,3.5,9.6,5.3 c1.8,1.7,1.5,1.3,1.5,1.3S59.5,14.9,55.4,16.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cn-bol_00000040551152815589599120000016086039526364497052_"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cn-globe_00000086657724552479187610000012773341326627168656_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.2,53c0-15.4-12.5-27.8-27.8-27.8c-6.8,0-13,2.4-17.8,6.5l39.2,39.2C93.8,65.9,96.2,59.7,96.2,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.6,31.6c-6.1,5.1-10,12.8-10,21.4c0,15.4,12.5,27.8,27.8,27.8c8.6,0,16.3-3.9,21.4-10L50.6,31.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cn-shadow_00000013895330884207731440000001720981002614297498_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M96.3,53.9c-0.5,15.4-13.4,27.4-28.8,26.8c-15.4-0.5-27.4-13.4-26.9-28.8c0.5-15.4,13.4-27.4,28.8-26.8 S96.8,38.5,96.3,53.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091720295932397087500000016012048798876326276_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cn_00000139978387855120088780000001240801610631416732_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,44.1c2.5-3.7,6.3-2,7.5-1.1c10.3,7.6,12.1,19.6,3.3,15c0,0,4.5,4,7.5,1.3c6.2-5.6-17.3-34.9-20.1-10.6 c0,0,5.2,7.2,8.3,11c19.7,24.2,5.9,16.8,5.9,16.8c0.3,0.3,1.3,0.8,1.6,1c1.7,0.7,2.6,0.9,3.5,0.9c8-0.7,1.3-10.2-12-27.1 C46.3,48.8,42.7,44.1,42.7,44.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.6,24.7c-9.8,5.2-2.3,14.9,6.4,26.1C79.9,67.5,87,76.5,77.9,80c-1.5,0.6-3,0.8-3.8,1 c8.7-2.9,3.2-10.1-6.2-21.9C55.7,43.8,47.7,30.8,56.8,26C57.9,25.4,59.1,25,60.6,24.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.7,24.7C50.4,29.3,60.1,37,71.3,45.9c16.4,13,24.2,20.3,17.8,27c-1.5,1.6-2.5,2.1-3,2.6 c6.5-6.6-0.7-12.7-17.3-26.2C57.6,40,48.5,30.6,57.1,26C58.1,25.5,59.1,25,60.7,24.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,23.9c-11.7-1.3-4.5,7.8-1.8,11.2c4.3,5.4,9,10.3,13.2,15.8c1.5,2,3.7,5.2,5.2,8.4 c3.4,7.4,1.5,10.9-0.9,13.7c-0.8,0.9-1,1-1,1c-1.1,1-2.4,1.9-2.4,1.9c6.2-5.8,3.9-13.7-10.3-30.7c-9-10.8-17.3-21.8-5.4-21.8 C71.1,23.4,72.4,23.7,73.5,23.9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromonetwerk01);
export default __webpack_public_path__ + "static/media/promonetwerk-01.c22646426368e63e9432282ca77b1ea1.svg";
export { ForwardRef as ReactComponent };